import styled from 'styled-components'

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  height: calc(100vh - 120px);
  width: 100%;
  padding: 24px;
  overflow: hidden;
  font-family: 'Montserrat', sans-serif;
  color: ${(props) => props.theme.textPrimary};
`

export const TopActions = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 20px;
  margin-bottom: 24px;
  width: 100%;

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: stretch;
  }
`

export const SearchWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  background: ${(props) => (props.theme.name === 'light' ? '#ffffff' : 'rgba(255, 255, 255, 0.05)')};
  border: 1px solid ${(props) => (props.theme.name === 'light' ? '#cbd5e1' : 'rgba(255, 255, 255, 0.1)')};
  border-radius: 12px;
  padding: 8px 16px;
  width: 100%;
  max-width: 400px;
  box-shadow: ${(props) => (props.theme.name === 'light' ? '0 2px 8px rgba(0, 31, 92, 0.04)' : 'none')};
  transition: all 0.3s ease;

  &:focus-within {
    border-color: #3b82f6;
    background: ${(props) => (props.theme.name === 'light' ? '#ffffff' : 'rgba(255, 255, 255, 0.08)')};
    box-shadow: 0 0 0 2px rgba(59, 130, 246, 0.2);
  }

  svg {
    color: ${(props) => (props.theme.name === 'light' ? '#64748b' : '#94a3b8')};
    font-size: 18px;
  }

  input {
    background: transparent;
    border: none;
    outline: none;
    color: ${(props) => props.theme.textPrimary};
    font-size: 14px;
    width: 100%;
    font-family: 'Montserrat', sans-serif;

    &::placeholder {
      color: ${(props) => (props.theme.name === 'light' ? '#94a3b8' : '#64748b')};
    }
  }
`

export const ActionButtonsGroup = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`

export const PrimaryButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  background: linear-gradient(135deg, #2563eb, #1d4ed8);
  color: #ffffff;
  border: none;
  border-radius: 12px;
  padding: 10px 20px;
  font-size: 14px;
  font-weight: 700;
  cursor: pointer;
  transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);
  box-shadow: 0 4px 12px rgba(37, 99, 235, 0.2);

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 6px 18px rgba(37, 99, 235, 0.35);
    background: linear-gradient(135deg, #3b82f6, #2563eb);
  }

  &:active {
    transform: translateY(0);
  }

  svg {
    font-size: 18px;
  }
`

export const RefreshButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 42px;
  height: 42px;
  border-radius: 12px;
  border: 1px solid ${(props) => (props.theme.name === 'light' ? '#cbd5e1' : 'rgba(255, 255, 255, 0.1)')};
  background: ${(props) => (props.theme.name === 'light' ? '#ffffff' : 'rgba(255, 255, 255, 0.05)')};
  color: ${(props) => (props.theme.name === 'light' ? '#0f172a' : '#ffffff')};
  box-shadow: ${(props) => (props.theme.name === 'light' ? '0 2px 8px rgba(0, 31, 92, 0.04)' : 'none')};
  cursor: pointer;
  transition: all 0.3s ease;

  &:hover {
    background: ${(props) => (props.theme.name === 'light' ? '#f1f5f9' : 'rgba(255, 255, 255, 0.12)')};
    border-color: #3b82f6;
    color: #3b82f6;
    transform: rotate(180deg);
  }

  svg {
    font-size: 18px;
  }
`

export const TabContainer = styled.div`
  display: flex;
  gap: 8px;
  border-bottom: 1px solid ${(props) => (props.theme.name === 'light' ? '#cbd5e1' : 'rgba(255, 255, 255, 0.1)')};
  margin-bottom: 24px;
  width: 100%;
`

interface TabButtonProps {
  $active: boolean
}

export const TabButton = styled.button<TabButtonProps>`
  background: transparent;
  border: none;
  outline: none;
  color: ${(props) => (props.$active ? props.theme.name === 'light' ? '#2563eb' : '#ffffff' : props.theme.name === 'light' ? '#475569' : '#64748b')};
  font-size: 15px;
  font-weight: 700;
  padding: 12px 24px;
  cursor: pointer;
  position: relative;
  transition: all 0.25s ease;
  font-family: 'Montserrat', sans-serif;

  &:hover {
    color: ${(props) => (props.theme.name === 'light' ? '#2563eb' : '#ffffff')};
  }

  &::after {
    content: '';
    position: absolute;
    bottom: -1px;
    left: 0;
    width: 100%;
    height: 3px;
    background: linear-gradient(90deg, #3b82f6, #2563eb);
    transform: scaleX(${(props) => (props.$active ? 1 : 0)});
    transition: transform 0.25s cubic-bezier(0.4, 0, 0.2, 1);
    border-radius: 3px 3px 0 0;
  }

  span.count {
    margin-left: 8px;
    font-size: 11px;
    padding: 2px 8px;
    border-radius: 20px;
    background: ${(props) => (props.$active ? 'rgba(59, 130, 246, 0.15)' : props.theme.name === 'light' ? '#e2e8f0' : 'rgba(255, 255, 255, 0.05)')};
    color: ${(props) => (props.$active ? '#2563eb' : props.theme.name === 'light' ? '#475569' : '#64748b')};
    transition: all 0.25s ease;
  }
`

export const CardList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  height: 100%;
  overflow-y: auto;
  padding-bottom: 40px;
  padding-right: 4px;

  /* Scrollbar Customization */
  &::-webkit-scrollbar {
    width: 6px;
  }
  &::-webkit-scrollbar-track {
    background: transparent;
  }
  &::-webkit-scrollbar-thumb {
    background: rgba(255, 255, 255, 0.1);
    border-radius: 10px;
  }
  &::-webkit-scrollbar-thumb:hover {
    background: rgba(255, 255, 255, 0.2);
  }
`

export const EmptyState = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 12px;
  height: 250px;
  color: #64748b;
  font-size: 16px;
  font-weight: 500;

  svg {
    font-size: 40px;
    opacity: 0.5;
  }
`

export const ModernCard = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 20px;
  background: ${(props) => props.theme.cardBackground};
  border: 1px solid ${(props) => props.theme.cardBorder};
  border-radius: 16px;
  padding: 20px 24px;
  transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);
  box-shadow: ${(props) => (props.theme.name === 'light' ? '0 4px 15px rgba(0, 31, 92, 0.06)' : '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)')};

  &:hover {
    transform: translateY(-2px);
    box-shadow: ${(props) => (props.theme.name === 'light' ? '0 8px 24px rgba(0, 31, 92, 0.1)' : '0 10px 20px -5px rgba(0, 0, 0, 0.3)')};
    border-color: rgba(59, 130, 246, 0.3);
  }

  @media (max-width: 1024px) {
    flex-direction: column;
    align-items: flex-start;
    gap: 16px;
  }
`

export const CardMainInfo = styled.div`
  display: flex;
  align-items: center;
  gap: 20px;
  flex-grow: 1;

  @media (max-width: 640px) {
    flex-direction: column;
    align-items: flex-start;
  }
`

interface AvatarCircleProps {
  $gradientType?: 'admin' | 'administrador' | 'suporte' | 'gestor' | 'dist' | 'distribuidor' | 'visualiador' | 'master' | 'conferente'
}

export const AvatarCircle = styled.div<AvatarCircleProps>`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 56px;
  height: 56px;
  border-radius: 50%;
  font-size: 18px;
  font-weight: 800;
  color: #ffffff;
  flex-shrink: 0;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.2);

  background: ${(props) => {
    switch (props.$gradientType) {
      case 'admin':
      case 'administrador':
        return 'linear-gradient(135deg, #f59e0b, #d97706)' // Amber/Gold
      case 'suporte':
        return 'linear-gradient(135deg, #0ea5e9, #0284c7)' // Sky/Cyan Blue
      case 'conferente':
        return 'linear-gradient(135deg, #ec4899, #be185d)' // Pink/Rose
      case 'gestor':
        return 'linear-gradient(135deg, #6366f1, #4338ca)' // Indigo
      case 'dist':
      case 'distribuidor':
        return 'linear-gradient(135deg, #3b82f6, #1d4ed8)' // Blue
      case 'visualiador':
      case 'master':
        return 'linear-gradient(135deg, #10b981, #047857)' // Teal/Emerald
      default:
        return 'linear-gradient(135deg, #6b7280, #374151)' // Gray
    }
  }};
`

export const InfoDetails = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;

  .name-wrapper {
    display: flex;
    align-items: center;
    gap: 10px;
    flex-wrap: wrap;

    h3 {
      font-size: 16px;
      font-weight: 700;
      color: ${(props) => props.theme.textPrimary};
    }
  }

  .meta-wrapper {
    display: flex;
    align-items: center;
    gap: 16px;
    flex-wrap: wrap;
    color: ${(props) => (props.theme.name === 'light' ? '#475569' : '#94a3b8')};
    font-size: 13px;
    font-weight: 500;

    .item {
      display: flex;
      align-items: center;
      gap: 6px;

      svg {
        font-size: 14px;
        color: #64748b;
      }
    }
  }
`

interface BadgeProps {
  $type?: 'admin' | 'administrador' | 'suporte' | 'gestor' | 'dist' | 'distribuidor' | 'visualiador' | 'master' | 'conferente'
}

export const BadgeRole = styled.span<BadgeProps>`
  font-size: 10px;
  font-weight: 800;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  padding: 3px 8px;
  border-radius: 6px;
  background: ${(props) => {
    switch (props.$type) {
      case 'admin':
      case 'administrador':
        return 'rgba(245, 158, 11, 0.15)'
      case 'suporte':
        return 'rgba(14, 165, 233, 0.15)'
      case 'conferente':
        return 'rgba(236, 72, 153, 0.15)'
      case 'gestor':
        return 'rgba(99, 102, 241, 0.15)'
      case 'dist':
      case 'distribuidor':
        return 'rgba(59, 130, 246, 0.15)'
      case 'visualiador':
      case 'master':
        return 'rgba(16, 185, 129, 0.15)'
      default:
        return 'rgba(107, 114, 128, 0.15)'
    }
  }};
  color: ${(props) => {
    switch (props.$type) {
      case 'admin':
      case 'administrador':
        return '#f59e0b'
      case 'suporte':
        return '#38bdf8'
      case 'conferente':
        return '#f472b6'
      case 'gestor':
        return '#818cf8'
      case 'dist':
      case 'distribuidor':
        return '#60a5fa'
      case 'visualiador':
      case 'master':
        return '#34d399'
      default:
        return '#9ca3af'
    }
  }};
`

interface StatusProps {
  $isActive: boolean
}

export const StatusTag = styled.button<StatusProps>`
  display: flex;
  align-items: center;
  gap: 6px;
  background: ${(props) => (props.$isActive ? 'rgba(34, 197, 94, 0.12)' : 'rgba(239, 68, 68, 0.12)')};
  border: 1px solid ${(props) => (props.$isActive ? 'rgba(34, 197, 94, 0.2)' : 'rgba(239, 68, 68, 0.2)')};
  color: ${(props) => (props.$isActive ? '#4ade80' : '#f87171')};
  font-size: 12px;
  font-weight: 700;
  padding: 4px 10px;
  border-radius: 20px;
  cursor: pointer;
  transition: all 0.2s ease;
  font-family: 'Montserrat', sans-serif;

  &:hover {
    background: ${(props) => (props.$isActive ? 'rgba(34, 197, 94, 0.2)' : 'rgba(239, 68, 68, 0.2)')};
    transform: scale(1.03);
  }

  &::before {
    content: '';
    width: 6px;
    height: 6px;
    border-radius: 50%;
    background: ${(props) => (props.$isActive ? '#22c55e' : '#ef4444')};
  }
`

export const CardActions = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;

  @media (max-width: 1024px) {
    align-self: flex-end;
  }
`

export const IconButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 38px;
  height: 38px;
  border-radius: 10px;
  border: 1px solid rgba(255, 255, 255, 0.05);
  background: rgba(255, 255, 255, 0.03);
  color: #94a3b8;
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    background: rgba(255, 255, 255, 0.1);
    color: #ffffff;
    border-color: rgba(255, 255, 255, 0.2);
    transform: translateY(-1px);
  }

  &.edit:hover {
    color: #fbbf24;
    border-color: rgba(251, 191, 36, 0.3);
    background: rgba(251, 191, 36, 0.08);
  }

  &.send:hover {
    color: #3b82f6;
    border-color: rgba(59, 130, 246, 0.3);
    background: rgba(59, 130, 246, 0.08);
  }

  &.toggle-status:hover {
    color: #ef4444;
    border-color: rgba(239, 68, 68, 0.3);
    background: rgba(239, 68, 68, 0.08);
  }

  svg {
    font-size: 16px;
  }
`
